import { Route } from '@angular/router';
import { HomeRoutes } from './home/home.routes';
import { CorpComponent } from './corp.component';
import { UserAuthGuardService } from '../services/user-auth-guard.service';

export const CorpRoutes: Route[] = [
    {
      path: '',
      component: CorpComponent,
      /*canActivate: [UserAuthGuardService],*/
      children: [
        ...HomeRoutes,
      ]
      
      
    },
    
];



// WEBPACK FOOTER //
// ./src/app/corp/corp.routes.ts